/** Client-side video metadata check (same idea as competition enter flow). */
export function probeClientDuration(file) {
  return new Promise((resolve) => {
    if (!file) {
      resolve(null);
      return;
    }
    try {
      const url = URL.createObjectURL(file);
      const video = document.createElement("video");
      video.preload = "metadata";
      video.onloadedmetadata = () => {
        const duration = video.duration;
        URL.revokeObjectURL(url);
        resolve(Number.isFinite(duration) ? duration : null);
      };
      video.onerror = () => {
        URL.revokeObjectURL(url);
        resolve(null);
      };
      video.src = url;
    } catch (error) {
      resolve(null);
    }
  });
}

export const MAX_DRESS_VIDEO_SEC = 600;
